module.exports = __webpack_public_path__ + "static/media/site-builder-v2-es.85695491.png";